export const MESSAGE_TYPE_ROOM_NAME_CHANGED = 'r';
export const MESSAGE_TYPE_USER_ADDED = 'au';
export const MESSAGE_TYPE_USER_REMOVED = 'ru';
export const MESSAGE_TYPE_USER_JOINED = 'uj';
export const MESSAGE_TYPE_USER_LEFT = 'ul';
export const MESSAGE_TYPE_WELCOME = 'wm';
export const MESSAGE_TYPE_LIVECHAT_CLOSED = 'livechat-close';
export const MESSAGE_TYPE_LIVECHAT_STARTED = 'livechat-started';
export const MESSAGE_TYPE_LIVECHAT_TRANSFER_HISTORY = 'livechat_transfer_history';
